import {
  Image,
  ScrollView,
  StyleSheet,
  Text,
  TouchableOpacity,
  View,
} from 'react-native';
import React, { FC, useCallback, useEffect, useState } from 'react';
import { EventsLayoutProps } from './EventsLayout.types';
import PagePath from '../../components/PagePath';
import UserWebInfo from '../../components/UserWebInfo';
import PageTitle from '../../components/PageTitle';
import { Footer } from '../../components/Footer';
import { STYLE_VARS } from '../../constants/style-vars';
import { IS_WEB } from '../../constants/platform';
import { addBase64Prefix } from '../../services/addBase64Prefix';
import { filter_button, reset_icon } from '../../assets/base64';
import { NavigationService } from '../../services/navigation';
import { EventsApi } from '../../services/api';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../services/redux';
import { styles } from './EventsLayout.styled';
import {
  EventFilter,
  setEventFilter,
  setEvents,
  setLoadingEvent,
  setTotal,
} from '../../services/redux/reducers/EventSlice';
import { decode } from 'html-entities';

type EventCategory = {
  id: number;
  name: string;
  slug: string;
  description: string;
  parent: number;
  child?: EventCategory[];
};

const EventsLayout: FC<EventsLayoutProps> = ({ children, scrollViewRef }) => {
  const dispatch = useDispatch();
  const { eventFilter } = useSelector((state: RootState) => state.eventReducer);

  const [eventCategories, setEventCategories] = useState<EventCategory[]>([]);
  const [filterSelected, setFilterSelected] = useState<EventCategory[]>([]);

  const getEvents = useCallback(
    async (props: EventFilter) => {
      try {
        dispatch(setLoadingEvent(true));
        const res = await EventsApi.getEvents(props);
        dispatch(setEvents(res.data.events));
        dispatch(setTotal(res.data.total));
        console.log('total', res.data.total);
      } catch (error: any) {
        console.log(error);
      } finally {
        dispatch(setLoadingEvent(false));
      }
    },
    [dispatch]
  );

  const handleGetEventCategoriesData = useCallback(async () => {
    try {
      const res = await EventsApi.getEventsCategory({});
      const data = res.data;
      let categories: EventCategory[] = [];
      for (let i = 0; i < data.length; i++) {
        let category: EventCategory = {
          ...data[i],
          child: [],
        };
        if (category.parent === 0) {
          category.child = data.filter((e) => e.parent === category.id);
          categories.push(category);
        }
      }
      setEventCategories(categories);
    } catch (error: any) {
      console.log(error);
    } finally {
    }
  }, [setEventCategories]);

  useEffect(() => {
    const filters = filterSelected.filter(
      (filter) => !filter.child || filter.child.length === 0
    );
    const slugArray = filters.map((obj) => obj.slug);
    const resultString = slugArray.join(',');
    if (resultString !== eventFilter.cats) {
      dispatch(setEvents([]));
      getEvents({
        ...eventFilter,
        cats: resultString,
        page: 1,
      });
      dispatch(
        setEventFilter({
          ...eventFilter,
          cats: resultString,
          page: 1,
        })
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterSelected, dispatch, getEvents]);

  const handleFilterSelect = useCallback(
    (selected: EventCategory) => {
      if (filterSelected.includes(selected)) {
        const arr = filterSelected.filter((filter) => filter !== selected);
        setFilterSelected(arr);
      } else {
        const arr = [...filterSelected, selected];
        setFilterSelected(arr);
      }
    },
    [filterSelected]
  );
  const handleFilterReset = useCallback(() => {
    setFilterSelected([]);
    getEvents({
      ...eventFilter,
      cats: '',
      page: 1,
    });
    dispatch(
      setEventFilter({
        ...eventFilter,
        cats: '',
        page: 1,
      })
    );
  }, [getEvents, eventFilter, dispatch]);

  useEffect(() => {
    handleGetEventCategoriesData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <ScrollView showsVerticalScrollIndicator={false} ref={scrollViewRef}>
      <View
        style={{
          maxWidth: 1250,
          width: '90%',
          marginHorizontal: 'auto',
          marginTop: 10,
          minHeight: 500,
          zIndex: 1,
        }}
      >
        <PagePath
          pathSteps={[
            {
              name: 'Member Area',
              onPress: () => {
                NavigationService.push('Root', {
                  screen: 'HomeTab',
                });
              },
            },
            { name: 'Events' },
          ]}
        />
        <View style={styles.container}>
          <View style={{ width: '20%', minWidth: 230, marginRight: 20 }}>
            <UserWebInfo />
            <View style={{ marginTop: 60 }}>
              <View style={styles.filterWrapper}>
                <Image
                  source={
                    IS_WEB
                      ? addBase64Prefix(filter_button)
                      : require('../../assets/phone-white.png')
                  }
                  style={{ width: 24, height: 24, marginRight: 8 }}
                />
                <Text style={styles.filterText}>Filter Event</Text>
              </View>
              <View style={{ flexDirection: 'column' }}>
                {eventCategories.map((category) => (
                  <TouchableOpacity
                    style={[styles.selectWrapper, { alignSelf: 'flex-start' }]}
                    key={category.id}
                    onPress={() => handleFilterSelect(category)}
                  >
                    <View style={styles.selectedBox}>
                      {filterSelected.includes(category) && (
                        <View
                          style={{
                            width: '100%',
                            height: '100%',
                            borderColor: STYLE_VARS.primaryColor,
                            borderWidth: 5,
                          }}
                        ></View>
                      )}
                    </View>
                    <Text style={styles.selectedText}>
                      {decode(category.name)}
                    </Text>
                  </TouchableOpacity>
                ))}
                {filterSelected.map((selected) => {
                  if (selected.child && selected.child.length > 0) {
                    return (
                      <View key={selected.id}>
                        <View
                          style={{ flexDirection: 'row', marginBottom: 20 }}
                        >
                          <View>
                            <Image
                              source={
                                IS_WEB
                                  ? addBase64Prefix(filter_button)
                                  : require('../../assets/phone-white.png')
                              }
                              style={{ width: 17, height: 17, marginRight: 8 }}
                            />
                          </View>
                          <Text style={styles.selectedText}>
                            ALL {decode(selected.name)}
                          </Text>
                        </View>
                        {selected.child.map((filter) => (
                          <TouchableOpacity
                            style={[
                              styles.selectWrapper,
                              { alignSelf: 'flex-start' },
                            ]}
                            key={filter.id}
                            onPress={() => handleFilterSelect(filter)}
                          >
                            <View style={styles.selectedBox}>
                              {filterSelected.includes(filter) && (
                                <View
                                  style={{
                                    width: '100%',
                                    height: '100%',
                                    borderColor: STYLE_VARS.primaryColor,
                                    borderWidth: 5,
                                  }}
                                ></View>
                              )}
                            </View>
                            <Text style={styles.selectedText}>
                              {decode(filter.name)}
                            </Text>
                          </TouchableOpacity>
                        ))}
                      </View>
                    );
                  }
                })}
                <TouchableOpacity
                  style={[styles.selectWrapper, { alignSelf: 'flex-start' }]}
                  onPress={() => handleFilterReset()}
                >
                  <Image
                    source={
                      IS_WEB
                        ? addBase64Prefix(reset_icon)
                        : require('../../assets/reset-icon.png')
                    }
                    style={{
                      width: 17,
                      height: 17,
                      marginRight: 8,
                    }}
                  />
                  <Text style={styles.selectedText}>RESET FILTER</Text>
                </TouchableOpacity>
              </View>
            </View>
          </View>
          <View style={{ width: '75%' }}>
            <PageTitle
              title="Events"
              icon={require('../../assets/events.png')}
              haveBottomLine={false}
            />
            <View>{children}</View>
          </View>
        </View>
      </View>
      <Footer />
    </ScrollView>
  );
};

export default EventsLayout;
